"use client";

import Link from "next/link";
import { useTranslation } from "../hooks/useTranslation";
import {
  getWeekPrizeConfig,
  getWeekPrizeSlotForWeek,
  type WeekPrizeSlot,
} from "@/lib/weekPrizes";

type WeekPrizeWidgetProps = {
  weekId: number;
  /** `competitionData.weeks` — missing week numbers don’t shift the prize cycle. */
  scheduleWeeks?: { weekId: number }[] | null;
};

export function WeekPrizeWidget({ weekId, scheduleWeeks }: WeekPrizeWidgetProps) {
  const { t } = useTranslation();
  const slot: WeekPrizeSlot = getWeekPrizeSlotForWeek(weekId, scheduleWeeks);
  const { imageSrc, titleKey } = getWeekPrizeConfig(slot);

  return (
    <div className="relative rounded-2xl px-4 py-4 flex flex-col items-center justify-center gap-0 w-full h-full overflow-hidden bg-[var(--bet-red)] bg-[url('/assets/08ad33feace27a993b49a609da61c5e4962b1a0d.png')] bg-cover bg-center">
      <div className="flex flex-col font-['PanamaBold'] justify-center leading-[0] text-[16px] text-white text-center w-full relative z-10 flex-shrink-0 px-1">
        <p className="leading-[18px] m-0">{t("predictions.playingForThisWeek")}</p>
      </div>

      <div className="flex flex-col items-center gap-2 w-full relative z-10 min-w-0">
        {/* eslint-disable-next-line @next/next/no-img-element -- same asset pattern as /prizes */}
        <img
          src={imageSrc}
          alt={t(titleKey)}
          className="max-h-32 md:max-h-36 w-auto max-w-full object-contain"
        />
        <p className="text-[12px] font-medium text-white text-center leading-snug">
          {t(titleKey)}
        </p>
        <Link
          href="/prizes"
          className="text-[12px] font-medium text-white hover:underline mt-1 w-fit text-center"
        >
          {t("predictions.viewAllPrizes")}
        </Link>
      </div>
    </div>
  );
}
